<template>
    <modal-dialog
        ref="modalDialog"
        :confirmBtnTxt="`Delete`"
        :isLoading="isLoading"
        @confirm-dialog="deleteAction"
    >
        <template v-slot:title>
            Delete Action
        </template>
        <template v-slot:body>
            Are you sure you want to permanently delete this action?
        </template>
    </modal-dialog>
</template>

<script>
import TemplateService from "@/services/templates";
import ModalDialog from "@/components/commons/modal-dialog";

export default {
    components: {
        ModalDialog
    },
    props: {},
    data() {
        return {
            isLoading: false,
            templateId: null,
            action: null
        };
    },
    methods: {
        open(templateId, action) {
            this.templateId = templateId;
            this.action = action;
            this.$refs.modalDialog.open();
        },
        deleteAction() {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;

            TemplateService.deleteAction(this.templateId, this.action.id)
                .then(res => {
                    if (res.message.code == 200) {
                        this.$emit("reload");
                        this._message("Action successfully deleted");
                        this.$refs.modalDialog.close();
                    } else {
                        this._message(
                            "Error: Unable to delete action",
                            "danger"
                        );
                    }
                })
                .catch(error => {
                    console.error(error);
                    this._message("Error: Unable to delete action", "danger");
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
};
</script>
